import { baseWords } from '@/tenant-data/base';

export const words = { ...baseWords };

export default words;
